import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../../layouts/sidebarProposal/SidebarProposal'
import ProjectBasicInfoSubProject from '../../../../widgets/projectBasicInfo/ProjectBasicInfoSubProject'
import BudgetSubproject from '../../../../widgets/budget/BudgetSubproject'
import { useParams, useHistory } from 'react-router-dom'
import {
  getPaymentCheck,
  savePaymentCheck,
  getPaymentCheckSubProject,
} from '../../../../redux/actions/paymentCheck'
import { startLoading, doneLoading } from '../../../../utils/loading'
import PanalLoadingTemplate from '../../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../../components/ContentHeader/ContentHeader'
import ErrorWidget from '../../../../widgets/errorWidget/ErrorWidget'
import pathname from '../../../../constants/pathname'
import { getSchemaSubPaymentSaveNew } from '../../../../redux/actions/paymentSave'

export default function PaymentCheckSubproject() {
  const [schema, setSchema] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSchemaSubPaymentSaveNew(proposalId)
      setSchema(_schema)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [])

  const handleConfirmBudget = async (_setIsLoading, _setIsError) => {
    startLoading()
    _setIsLoading(true)
    _setIsError(false)
    try {
      const _schema = await savePaymentCheck(projectId)
      doneLoading()
      // return history.push(`${pathname.proposal.approve.granteeForStaff}/${projectId}`)
      return history.push(`${pathname.proposal.approve.granteeForStaff}`)
    } catch (e) {
      _setIsError(true)
    }
    _setIsLoading(false)
    doneLoading()
  }

  if (error) {
    return (
      <SidebarProposal isSubProject>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProject>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isSubProject>
          <ContentHeader header={'ขั้นที่ 1 ตรวจสอบงวดเงิน'} subHeader={schema.subHeader} />

          <ProjectBasicInfoSubProject schema={schema.forms.projectInfo} />

          <br />

          <BudgetSubproject
            schema={schema?.forms}
            isEditable={false}
            defaultExpandAllRows={true}
            // isShowBudgetSubmitButton={true}
            onClickConfirmBudget={handleConfirmBudget}
          />
        </SidebarProposal>
      )}
    </>
  )
}
